import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import { API_ROUTES } from '@/constants/routes';
import type { WhatsappStats } from '@/types/outreach';

const KEYS = {
  all: ['whatsappStats'] as const,
  byPeriod: (period: string, templateId?: string) => [...KEYS.all, period, templateId] as const,
};

export const useWhatsappStats = (period: string = 'all', templateId?: string) => {
  return useQuery<WhatsappStats>({
    queryKey: KEYS.byPeriod(period, templateId),
    queryFn: async () => {
      const params: Record<string, string> = { period };
      if (templateId) params.template_id = templateId;
      const { data } = await api.get(API_ROUTES.whatsappStats, { params });
      return data;
    },
  });
};
